<template>
	<ul v-if="$props.paths.length" class="arm-breadcrumbs">
		<li
			v-for="(br, idx) in $props.paths"
			:key="br.armId"
			:class="['arm-breadcrumbs__item', { 'arm-breadcrumbs__item_active': idx === pathLength }]"
		>
			<template v-if="idx === pathLength">{{ br.armCaption }}</template>
			<template v-else>
				<a class="arm-breadcrumbs__link" :title="getArmLinkTitle(br)" @click="goToParent(br)">{{ br.armCaption }}</a>
				<template v-if="br.parentRecordName">: {{ br.parentRecordName }}</template>
			</template>
		</li>

		<li class="arm-breadcrumbs__back">
			<button	class="btn btn-default btn-xs" :title="getArmLinkTitle(prevPath)"	@click="goToParent(prevPath)">
				<i class="glyphicon glyphicon-chevron-left"></i> Назад
			</button>
		</li>
	</ul>
</template>

<script>
import childMixin from '@uarmSrc/mixins/child-nav-mixin.js'

/**
 * Хлебные крошки навигации внутри дочерних АРМов
 */
export default {
	name: 'ChildNavBar',
	props: {
		paths: {
			type: Array,
			required: true,
		},
	},
	mixins: [
		childMixin, // миксин с childNav_pathArray и методами для перехода в дочерние/родительские АРМ
	],
	computed: {
		pathLength() {
			return this.$props.paths.length - 1;
		},
		prevPath() {
			return this.pathLength > 0 ? this.$props.paths[this.pathLength - 1] : null;
		}
	},
	methods: {
		// Подсказка при наведении на элемент навигации
		getArmLinkTitle(path) {
			const where = path.isCard ? ('карточку записи №' + path.currentRecordId) : 'список записей';

			return 'Перейти в ' + where + ' АРМ №' + path.armId;
		},
		// Возврат назад по уровням навигации
		goToParent(path) {
			const targetArmId = path.armId;

			// обрезаем текущий childPath до выбранного в хлебных крошках пункта через временный массив и break
			const currentChildPath = this.childNav_getPathArray();
			const currentPaths = [];
			for (let i = 0; i < currentChildPath.length; i++) {
				currentPaths.push(currentChildPath[i])
				if (currentChildPath[i].armId === targetArmId) {
					// если ВДРУГ будут закольцованные пути АРМ - будет дефект
					// (когда корневой арм через несколько дочерних сам указан как дочерний)
					// надо просто с конца обрезать, через i--
					break;
				}
			}

			this.childNav_go(currentPaths, targetArmId);
		}
	}
}
</script>
